import { createFileRoute } from '@tanstack/react-router'
import { EntryPage } from '@/pages/entry'

export const Route = createFileRoute('/_app/entries/$entryId')({
	component: EntryPage,
})
